module.exports = __webpack_public_path__ + "static/media/pay_later.3e94e99d.png";